import {registerGraphNode} from "#graph/decorators/register-node"
import type {Evaluator} from "#graph/evaluators/types"
import {dynamicParameterDefinition} from "#graph/nodes/dynamic-parameter/definition"
import {GraphNode} from "#graph/nodes/graph/graph-node"
import {lazyDefinition} from "#graph/helpers/lazy-definition"
import {z} from "zod/v4-mini"
import type {ParameterValue} from "#graph/nodes/graph/helpers"

const dynamicParameterNodeDefinition = lazyDefinition(() => dynamicParameterDefinition<any>("DynamicParameter", z.any()))
const dynamicNumberParameterDefinition = lazyDefinition(() => dynamicParameterDefinition("DynamicNumberParameter", z.number()))

@registerGraphNode
export class DynamicParameter<ValueType, Context = unknown> extends GraphNode<ValueType, Context, {value: ParameterValue<ValueType>}> {
    public override get definition() {
        return dynamicParameterNodeDefinition()
    }

    set(value: ValueType) {
        this.replaceParameters({value})
    }

    override run = async (evaluator: Evaluator<Context>): Promise<ValueType> => {
        return evaluator.get(this.parameters.value)
    }

    override runSync = (evaluator: Evaluator<Context>): ValueType => {
        return evaluator.getSync(this.parameters.value)
    }
}

@registerGraphNode
export class DynamicNumberParameter<Context = unknown> extends DynamicParameter<number, Context> {
    public override get definition() {
        return dynamicNumberParameterDefinition()
    }
}
